import { render, staticRenderFns } from "./LearningMachine.vue?vue&type=template&id=5438c584&scoped=true&"
import script from "./LearningMachine.vue?vue&type=script&lang=js&"
export * from "./LearningMachine.vue?vue&type=script&lang=js&"
import style0 from "./LearningMachine.vue?vue&type=style&index=0&id=5438c584&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438c584",
  null
  
)

export default component.exports